import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetBatches from '@/modules/batches/api/hooks/useQueryGetBatches'
import BatchListing from '@/modules/batches/components/BatchListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function BatchPage() {
	const { pageSize, currentPage, searchQuery, selectedQuery } =
		useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
		status: selectedQuery as 'ACTIVE' | 'INACTIVE' | undefined,
	}

	const { data, isLoading } = useQueryGetBatches(payload)

	return (
		<PageContainer>
			<BatchListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedBatchPage = withUserPermission(BatchPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_COUPON],
})

export default GuardedBatchPage
